module.exports = __webpack_public_path__ + "img/bot-avatar.34628839.png";